module.exports = __webpack_public_path__ + "img/6-1_03.2ff5116b.jpg";